import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // brand
      brand: "EjarMint",
      // nav
      nav_marketplace: "Marketplace",
      nav_landlord: "My Facilities",
      nav_portfolio: "Portfolio",
      nav_tenant: "My Rentals",
      nav_amc: "AMC Desk",
      nav_activity: "Activity",
      nav_signin: "Sign in",
      nav_getstarted: "Get started",
      nav_wallet: "Wallet",
      nav_signout: "Sign out",
      // landing
      hero_tag: "Tokenized rent income · v1.0",
      hero_title_1: "Turn future rent into",
      hero_title_2: "tradable coins",
      hero_sub: "Buy fractional coins backed by real, signed leases. Earn a transparent monthly cashflow the day rent hits the platform — for the entire term. Owners get an instant advance, investors get the upside.",
      hero_cta_start: "Open an account →",
      hero_cta_calc: "Try the calculator",
      stat_raised: "Raised",
      stat_distributed: "Distributed",
      stat_yield_index: "Live yield index",
      stat_active_offerings: "Active offerings",
      // how it works
      how_tag: "How it works",
      how_title: "Four roles. One ledger. Zero ambiguity.",
      how_01_tag: "01 · Landlord",
      how_01_title: "Add facility & delegate AMC",
      how_01_body: "List the multi-unit facility with its aggregate rent, then delegate an Asset Management Company to verify and publish the offering.",
      how_02_tag: "02 · AMC",
      how_02_title: "Publish feasibility",
      how_02_body: "The AMC vets the cash flow, sets occupancy, maintenance, target APY and fees, then launches the ICO automatically.",
      how_03_tag: "03 · Investor",
      how_03_title: "Buy coins",
      how_03_body: "Pick an active ICO and buy any quantity. Each coin earns its share of the net monthly rent until expiry.",
      how_04_tag: "04 · Tenant",
      how_04_title: "Pay rent as usual",
      how_04_body: "Rent flows in once a month — AMC fee (covers O&M) is deducted, the rest is auto-distributed pro-rata to all coin holders. The landlord is hands-off until the term ends.",
      // calculator
      calc_tag: "What-if calculator",
      calc_title: "Plug in your deal. See every side.",
      calc_sub: "Adjust the inputs. The calculator instantly shows what each party gets — the landlord, the investor (that's you, if you're buying coins), and the tenant. Coin supply is fixed at 100,000 in this simulator; in a real offering the AMC can issue any amount.",
      calc_inputs: "Inputs",
      calc_rent: "Monthly rent",
      calc_duration: "Duration",
      calc_apy: "Target APY for investors",
      calc_occupancy: "Expected occupancy",
      calc_maint: "Monthly maintenance",
      calc_my_coins: "Coins YOU buy",
      calc_constants: "Computed constants",
      calc_return_per_coin: "RETURN / COIN / MO",
      calc_target_raise: "TARGET RAISE",
      calc_total_rent: "TOTAL RENT (TERM)",
      calc_advance_ratio: "RAISE / TOTAL RENT",
      calc_price_per_coin: "PRICE / COIN",
      calc_investor: "INVESTOR · you",
      calc_invest_pay: "YOU PAY · DAY 0",
      calc_monthly_in: "MONTHLY IN",
      calc_total_in: "TOTAL RECEIVED",
      calc_net_gain: "NET GAIN · ROI",
      calc_breakeven: "RECOVERY OF PRINCIPAL",
      calc_breakeven_label: "months to break-even",
      calc_landlord: "LANDLORD",
      calc_landlord_title: "Receives now — instead of waiting.",
      calc_cash_on_funding: "CASH ON FUNDING",
      calc_future_rent: "FUTURE RENT GIVEN UP",
      calc_cost_of_capital: "EFFECTIVE COST OF CAPITAL",
      calc_monthly_obligation: "MONTHLY RENT OBLIGATION",
      calc_tenant_role: "TENANT",
      calc_tenant_title: "Same rent. No surprises.",
      calc_tenant_bill: "MONTHLY BILL",
      calc_tenant_term_total: "TOTAL OVER TERM",
      calc_advance_required: "ADVANCE REQUIRED",
      calc_landlord_cannot_demand: "Landlord cannot demand prepayment.",
      coins_total: "coins",
      coin_supply_fixed: "Coin supply",
      coins_100k: "100,000 coins (simulator-fixed)",
      months: "months",
      // marketplace
      mp_tag: "Marketplace",
      mp_title: "Active offerings.",
      mp_filter_active: "active",
      mp_filter_funded: "funded",
      mp_filter_expired: "expired",
      mp_filter_all: "all",
      mp_empty: "No offerings yet",
      mp_view_offering: "View offering →",
      mp_investors: "{{count}} investors",

      // Recent Activity Ticker
      ticker_tag: "LIVE ON PLATFORM",
      ticker_purchase: "Coin purchase",
      ticker_funded: "ICO funded",
      ticker_distribution: "Distribution paid",
      ticker_rent: "Rent collected",
      mp_rent_per_mo: "Rent / mo",
      mp_coin_price: "Coin price",
      mp_yield_index_title: "Live weighted yield index",
      mp_yield_index_sub: "Average target APY across all active and funded offerings, weighted by raise size.",
      // why ejarmint
      why_tag: "Why EjarMint",
      why_title: "Built like a clearinghouse, priced like a marketplace.",
      why_b1: "Deterministic monthly distribution: monthly_rent ÷ coins_sold.",
      why_b2: "Owner gets the entire raise on the day of full funding.",
      why_b3: "Every coin has a known expiry — no perpetual obligations.",
      why_b4: "Investor returns scale linearly. No hidden fees in v1.",
      // CTA
      cta_title_1: "Open an account.",
      cta_title_2: "Start in under 60 seconds.",
      cta_btn: "Create account →",

      // Founding Team
      team_tag: "FOUNDING TEAM",
      team_title: "Built by operators, secured by counsel.",
      team_sub: "A small team with deep roots in data, finance, and Saudi corporate law — committed to making real-estate income accessible, compliant, and transparent.",
      team_1_name: "Abdullah Al-Nami",
      team_1_role: "Founder & CEO",
      team_1_bio: "Data scientist and AI specialist with 20+ years in tech. Former Saudi Aramco. MBA & BSc from KFUPM. Building EjarMint to turn rental cash flows into liquid investment.",
      team_1_link: "View LinkedIn →",
      team_2_name: "Dr. Adnan Al-Zahrani",
      team_2_role: "Legal & Compliance Counsel",
      team_2_bio: "Saudi-licensed attorney (SBA-registered professional firm). Specializes in real estate, financial services, Islamic banking, securities, and corporate governance.",
      team_2_link: "View SBA listing →",
      // login
      login_tag: "Sign in",
      login_title: "Welcome back.",
      login_email: "Email",
      login_password: "Password",
      login_submit: "Sign in →",
      login_no_account: "No account?",
      login_create: "Create one",
      // register
      reg_tag: "Create account",
      reg_title: "Pick a side.",
      reg_role: "Your role",
      reg_landlord: "Landlord",
      reg_investor: "Investor",
      reg_tenant: "Tenant",
      reg_amc: "Asset Mgr",
      reg_name: "Name",
      reg_submit: "Create account →",
      reg_have_account: "Have an account?",
      reg_signin: "Sign in",
      reg_demo: "Demo wallet · $50,000",
      reg_demo_body: "Every new account gets simulated cash to explore the platform end-to-end.",
      // common
      loading: "Loading…",
      processing: "Processing…",
      // ICO detail
      ico_buy: "Buy coins",
      ico_invest: "Invest",
      ico_target_apy: "TARGET APY",
      ico_quantity: "Quantity",
      ico_cost_now: "Cost now",
      ico_est_monthly: "Est. monthly",
      ico_est_total: "Est. total over term",
      ico_not_active: "Not active",
      ico_buy_n: "Buy {{n}} coins →",
      ico_owner: "Owner",
      ico_amc: "AMC",
      ico_units_title: "Units in this facility",
      ico_unit: "Unit",
      ico_rent: "Monthly rent",
      ico_tenant: "Tenant",
      ico_lease_end: "Lease end",
      ico_feas_title: "Feasibility study",
      ico_feas_by: "By",
      ico_returns_title: "How returns work",
      // landlord
      ll_tag: "Landlord",
      ll_title: "My facilities.",
      ll_add: "+ Add facility",
      ll_empty_title: "Add your first facility, then delegate an AMC to publish the feasibility.",
      ll_empty_tag: "No facilities yet",
      ll_status_ico_live: "ICO live",
      ll_status_awaiting: "awaiting study",
      ll_status_needs_amc: "needs AMC",
      ll_delegate_amc: "Delegate AMC",
      ll_change_tenant: "Change tenant",
      ll_assign_tenant: "Assign tenant",
      ll_view_ico: "View ICO",
      ll_units: "Units",
      ll_agg_rent: "Agg. rent",
      ll_amc: "AMC",
      // amc
      amc_tag: "Asset Management Desk",
      amc_title: "Facility requests.",
      amc_sub: "Owners delegate facilities to you. Verify the cash-flow, publish a feasibility study, and launch the offering — all in one form.",
      amc_pending: "Pending study",
      amc_publish: "Publish feasibility →",
      amc_view_ico: "View live ICO",
      amc_empty: "Ask owners to assign your AMC account to their facilities.",
      // wallet/activity
      wal_tag: "Wallet",
      wal_title: "Balance.",
      wal_current: "Current balance",
      wal_topup_tag: "Top-up (simulated)",
      wal_topup_title: "Add funds",
      wal_amount: "Amount (USD)",
      wal_add: "Add",
      act_tag: "Activity",
      act_title: "Ledger.",
      act_empty: "No activity yet",
      act_when: "When",
      act_type: "Type",
      act_desc: "Description",
      act_amount: "Amount",
      // currency
      currency_label: "Currency",
      // landlord dashboard
      ll_add_facility: "Add facility",
      ll_facility_name: "Facility name",
      ll_address: "Address",
      ll_image_url: "Image URL (optional)",
      ll_description: "Description",
      ll_units_header: "Units",
      ll_aggregate_rent: "Aggregate rent",
      ll_add_unit: "+ Unit",
      ll_unit_name: "Unit name",
      ll_unit_rent: "Monthly rent",
      ll_unit_tenant: "Tenant name (optional)",
      ll_unit_lease_end: "Lease end",
      ll_create_facility: "Create facility",
      ll_choose_amc: "Choose AMC",
      ll_amc_pick: "Pick a registered AMC…",
      ll_amc_none: "No AMCs registered yet",
      ll_amc_help: "The AMC will verify the facility, set occupancy/return assumptions, and launch the ICO on your behalf.",
      ll_delegate_btn: "Delegate",
      ll_tenant_email: "Tenant email",
      ll_tenant_help: "For demo simplicity, one platform tenant pays the aggregate monthly rent. The AMC handles per-unit leasing off-platform.",
      ll_assign_btn: "Assign",
      // amc dashboard
      amc_publish_dialog: "Feasibility",
      amc_agg_rent: "Aggregate monthly rent",
      amc_units: "Units",
      amc_owner: "Owner",
      amc_f_hist_rent: "Historical annual rent",
      amc_f_occupancy: "Expected occupancy %",
      amc_f_growth: "Expected rent growth %/yr",
      amc_f_maint: "Monthly maintenance cost",
      amc_f_apy: "Target APY for investors %",
      amc_f_duration: "Duration (months)",
      amc_f_monthly_fee: "AMC monthly fee % (of effective rent)",
      amc_f_setup_fee: "AMC setup fee % (of target raise)",
      amc_f_total_coins: "Total coins issued",
      amc_f_comment: "AMC comment / executive summary",
      amc_f_comment_ph: "Key risks, market view, leasing strategy…",
      amc_math_title: "Live math preview",
      amc_math_eff: "Effective / mo",
      amc_math_net: "Net to investors / mo",
      amc_math_raise: "Target raise",
      amc_math_price: "Price / coin",
      amc_math_advance: "Landlord advance",
      amc_math_setup: "AMC setup fee",
      amc_math_monthly: "AMC monthly fee",
      amc_math_apy: "Target APY",
      amc_submit: "Publish & launch ICO",
      // investor portfolio
      port_tag: "Investor",
      port_title: "Portfolio.",
      port_invested: "Total invested",
      port_earned: "Total earned",
      port_next_month: "Est. next month",
      port_holdings: "Holdings",
      port_empty: "No holdings yet.",
      port_browse: "Browse marketplace →",
      port_col_property: "Property",
      port_col_coins: "Coins",
      port_col_invested: "Invested",
      port_col_earned: "Earned",
      port_col_monthly: "Monthly",
      port_col_progress: "Progress",
      // tenant
      ten_tag: "Tenant",
      ten_title: "My rentals.",
      ten_empty_title: "No assigned rentals.",
      ten_empty_sub: "Ask your landlord to assign your account to a property.",
      ten_rent_label: "Rent",
      ten_last_paid: "Last paid",
      ten_next: "Next",
      ten_pay_btn: "Pay {{amount}} for month #{{n}} →",
      // Journey calculator stages
      jc_title: "Walk through the deal — stage by stage.",
      jc_sub: "Each stage shows what the role brings (inputs) and what they receive (outputs). Numbers update live as you tweak any input.",
      jc_stage_in: "INPUTS",
      jc_stage_out: "OUTPUTS",
      jc_stage_role: "ROLE",
      // 01 Landlord
      jc1_step: "01",
      jc1_role: "Landlord",
      jc1_title: "Register the facility",
      jc1_desc: "Lists the facility with its aggregate monthly rent and the desired term.",
      jc1_in_rent: "Aggregate monthly rent",
      jc1_in_duration: "Term",
      jc1_in_net_annual: "Avg net annual income (last 3 yrs)",
      jc1_in_years: "Years offered to investors",
      jc1_in_discount: "Total potential investor gain (%) over term",
      jc1_out_total: "Total future net income over term",
      jc1_out_discount: "Total potential investor gain (amount) over term",
      jc1_out_landlord_today: "Expected net cash today for landlord",
      tip_net_annual: "Average annual income after operating + maintenance costs, taken from the facility's last 3 years.",
      tip_years: "Number of future years of net income to tokenise (term length).",
      tip_discount: "Total return offered to investors over the whole term (e.g. 20% = investors receive 1.2× what they paid).",
      tip_total_net: "annual_net_income × years_offered",
      tip_discount_total: "total_future_net − target_raise — total gain handed to investors over the term.",
      tip_landlord_today: "total_future_net − total_investor_discount — what the landlord effectively receives today.",
      tip_occ: "Expected average occupancy rate across the term.",
      tip_maint: "Estimated monthly maintenance cost — paid to the AMC, which handles all O&M during the term.",
      tip_apy: "Annualised return rate the AMC promises investors.",
      tip_mfee: "Percentage of the monthly net income that goes to the AMC.",
      tip_sfee: "Percentage of the target raise paid to the AMC at full funding.",
      tip_eff: "monthly_net_income (already after maintenance & operating costs)",
      tip_net: "monthly_net_income × (1 − AMC_monthly_fee%)",
      tip_raise: "total_future_net_income ÷ (1 + investor_discount%)",
      tip_price: "target_raise ÷ 100,000",
      tip_advance: "target_raise − AMC_setup_fee",
      tip_sfee_out: "target_raise × AMC_setup_fee%",
      tip_mfee_out: "monthly_net_income × AMC_monthly_fee%",
      tip_coins: "How many of the 100,000 coins you choose to own.",
      tip_pay: "coins × price_per_coin",
      tip_monthly: "coins × (net_to_investors ÷ 100,000)",
      tip_total_in: "monthly_return × months",
      tip_roi: "(total_received − paid) ÷ paid",
      tip_net_gain: "total_received − paid",
      tip_apy_simple: "Total ROI ÷ years_offered (simple, not compound)",
      tip_be: "paid ÷ monthly_return",
      tip_t_pay: "Same monthly amount the tenant has always paid.",
      tip_advance_req: "The platform never asks the tenant for an advance.",
      tip_split: "Each $1 of net income splits between the AMC and the coin holders.",
      tip_term_total: "Total net income that passes through the platform during the term.",
      // CTAs + share
      share_link: "Copy share link",
      share_card: "Download share card (PNG)",
      share_copied: "Link copied to clipboard",
      apply_landlord: "Use these numbers as a landlord →",
      apply_amc: "Use these numbers as an AMC →",
      apply_register: "Sign up to apply →",
      scenario_loaded: "Calculator scenario applied to this form",
      // ICO tooltips
      tip_ico_rent: "Aggregate monthly rent across all units of the facility.",
      tip_ico_duration: "How many months the offering will distribute rent to coin holders.",
      tip_ico_coins: "Total coins issued for this offering.",
      tip_ico_price: "What an investor paid for each coin at issuance.",
      tip_ico_return: "Net monthly rent ÷ total coins — the share earned by every coin every month.",
      tip_ico_raise: "What the AMC plans to raise (price × total coins).",
      tip_ico_sold: "Coins purchased so far. When this equals total coins, the ICO is fully funded.",
      tip_ico_distributed: "Cumulative amount already distributed to coin holders since launch.",
      tip_ico_apy: "Target annualised return promised by the feasibility study.",
      // 02 AMC
      jc2_step: "02",
      jc2_role: "AMC · Asset Manager",
      jc2_title: "Publish feasibility",
      jc2_desc: "Sets occupancy, maintenance, target APY and AMC fees. The platform derives the entire offering math.",
      jc2_in_occ: "Expected occupancy",
      jc2_in_maint: "Monthly maintenance",
      jc2_in_apy: "Target APY for investors",
      jc2_in_mfee: "AMC monthly fee % (of effective rent)",
      jc2_in_sfee: "AMC setup fee % (of target raise)",
      jc2_out_eff: "Effective monthly rent",
      jc2_out_net: "Net to investors / month",
      jc2_out_raise: "Target raise (advance available)",
      jc2_out_price: "Price per coin (100k fixed)",
      jc2_out_advance: "Landlord receives on full funding",
      jc2_out_sfee: "AMC setup fee (paid at funding)",
      jc2_out_mfee: "AMC monthly fee (every month)",
      // 03 Investor
      jc3_step: "03",
      jc3_role: "Investor",
      jc3_title: "Buy coins",
      jc3_desc: "Picks how many coins to buy at the price set by the AMC feasibility.",
      jc3_in_coins: "Coins to buy",
      jc3_out_pay: "Cash you pay today",
      jc3_out_monthly: "Monthly return to your wallet",
      jc3_out_total: "Total received over term",
      jc3_out_net: "Net gain",
      jc3_out_roi: "Total ROI",
      jc3_out_apy: "Annualised (simple)",
      jc3_out_be: "Months to break-even",
      // 04 Tenant
      jc4_step: "04",
      jc4_role: "Tenant",
      jc4_title: "Pay rent — automatic distribution",
      jc4_desc: "Every month the tenant pays the same rent. The platform splits it: AMC fee + O&M → AMC, the rest → coin holders. Landlord is uninvolved until the term completes (then gets the asset back or renews via a new offering).",
      jc4_in_pay: "Monthly bill (same as today)",
      jc4_in_advance: "Advance required",
      jc4_out_split: "Where each monthly rent dollar goes",
      jc4_out_split_maint: "Maintenance · AMC",
      jc4_out_split_amc: "AMC fee",
      jc4_out_split_inv: "Net to all coin holders",
      jc4_out_term_total: "Total rent paid over the entire term",
    },
  },
  ar: {
    translation: {
      brand: "إيجار مِنت",
      nav_marketplace: "سوق الطروحات",
      nav_landlord: "منشآتي",
      nav_portfolio: "محفظة الاستثمارات",
      nav_tenant: "إيجاراتي",
      nav_amc: "مكتب إدارة الأصول",
      nav_activity: "سجل العمليات",
      nav_signin: "تسجيل الدخول",
      nav_getstarted: "ابدأ الآن",
      nav_wallet: "المحفظة",
      nav_signout: "تسجيل الخروج",
      hero_tag: "تمويل الإيجارات المستقبلية برموز رقمية · الإصدار ١٫٠",
      hero_title_1: "حوِّل الإيجارات المستقبلية إلى",
      hero_title_2: "عملات قابلة للتداول",
      hero_sub: "اشترِ عملات جزئية مدعومة بعقود إيجار موقَّعة. واحصل على تدفق نقدي شهري شفّاف فور تحصيل الإيجار من المستأجر — طوال مدة الطرح. المالك يحصل على دفعة مقدَّمة فورية، والمستثمر يحصل على عائد مجزٍ.",
      hero_cta_start: "افتح حساباً ←",
      hero_cta_calc: "جرّب الحاسبة",
      stat_raised: "إجمالي التمويل",
      stat_distributed: "إجمالي التوزيعات",
      stat_yield_index: "مؤشر العائد المباشر",
      stat_active_offerings: "الطروحات النشطة",
      how_tag: "آلية العمل",
      how_title: "أربعة أدوار. سجل واحد. شفافية تامة.",
      how_01_tag: "٠١ · المالك",
      how_01_title: "أضف المنشأة ووكِّل شركة إدارة الأصول",
      how_01_body: "أَدرِج المنشأة متعددة الوحدات بإيجارها الإجمالي، ثم وكِّل شركة إدارة أصول لاعتماد دراسة الجدوى وإطلاق الطرح.",
      how_02_tag: "٠٢ · شركة إدارة الأصول",
      how_02_title: "اعتماد دراسة الجدوى",
      how_02_body: "تتحقّق الشركة من التدفقات النقدية، وتحدِّد نسبة الإشغال ومصاريف الصيانة والعائد السنوي المستهدف والرسوم، ثم يُطلَق الطرح تلقائياً.",
      how_03_tag: "٠٣ · المستثمر",
      how_03_title: "اشترِ العملات",
      how_03_body: "اختَر طرحاً نشطاً واشترِ أي عدد من العملات. تحصل كل عملة على نصيبها من صافي الإيجار شهرياً حتى انتهاء المدة.",
      how_04_tag: "٠٤ · المستأجر",
      how_04_title: "ادفع الإيجار كالمعتاد",
      how_04_body: "يُحصَّل الإيجار شهرياً — تُخصَم رسوم شركة الإدارة (تشمل التشغيل والصيانة)، ويُوزَّع الباقي تلقائياً ونسبياً على جميع حاملي العملات. لا يتدخل المالك حتى انتهاء المدة.",
      calc_tag: "حاسبة السيناريو",
      calc_title: "أَدخِل بيانات الصفقة. شاهد عوائد جميع الأطراف.",
      calc_sub: "عدِّل المُدخلات لتظهر الأرقام لحظياً لكل طرف — المالك، والمستثمر (أنت إن كنت ستشتري عملات)، والمستأجر. عدد العملات ثابت عند ١٠٠٬٠٠٠ في المحاكاة؛ في الطرح الفعلي تستطيع شركة إدارة الأصول إصدار أي عدد.",
      calc_inputs: "المُدخلات",
      calc_rent: "الإيجار الشهري",
      calc_duration: "مدة الطرح",
      calc_apy: "العائد السنوي المستهدف",
      calc_occupancy: "نسبة الإشغال المتوقّعة",
      calc_maint: "الصيانة الشهرية",
      calc_my_coins: "عدد العملات التي ستشتريها",
      calc_constants: "القيم المحسوبة",
      calc_return_per_coin: "العائد · للعملة · شهرياً",
      calc_target_raise: "قيمة التمويل المستهدفة",
      calc_total_rent: "إجمالي الإيجار خلال المدّة",
      calc_advance_ratio: "التمويل ÷ إجمالي الإيجار",
      calc_price_per_coin: "سعر العملة",
      calc_investor: "المستثمر · أنت",
      calc_invest_pay: "تدفع · يوم ٠",
      calc_monthly_in: "العائد الشهري",
      calc_total_in: "إجمالي ما ستستلمه",
      calc_net_gain: "صافي الربح · العائد",
      calc_breakeven: "استرداد رأس المال",
      calc_breakeven_label: "شهراً حتى نقطة التعادل",
      calc_landlord: "المالك",
      calc_landlord_title: "يستلم نقداً الآن — بدلاً من الانتظار.",
      calc_cash_on_funding: "النقد عند اكتمال التمويل",
      calc_future_rent: "إيجار مستقبلي مُتنازَل عنه",
      calc_cost_of_capital: "التكلفة الفعلية لرأس المال",
      calc_monthly_obligation: "الإيجار الشهري على المستأجر",
      calc_tenant_role: "المستأجر",
      calc_tenant_title: "نفس الإيجار. بلا مفاجآت.",
      calc_tenant_bill: "الفاتورة الشهرية",
      calc_tenant_term_total: "الإجمالي خلال المدّة",
      calc_advance_required: "المطلوب دفعه مقدّماً",
      calc_landlord_cannot_demand: "لا يحقّ للمالك مطالبة المستأجر بدفعةٍ مقدّمة.",
      coins_total: "عملة",
      coin_supply_fixed: "عدد العملات المُصدَرة",
      coins_100k: "١٠٠٬٠٠٠ عملة (ثابت في المحاكاة)",
      months: "شهراً",
      mp_tag: "السوق",
      mp_title: "الطروحات النشطة.",
      mp_filter_active: "نشط",
      mp_filter_funded: "مكتمل التمويل",
      mp_filter_expired: "منتهٍ",
      mp_filter_all: "الكل",
      mp_empty: "لا توجد طروحات بعد",
      mp_view_offering: "عرض الطرح ←",
      mp_investors: "{{count}} مستثمرون",

      // مؤشر النشاط المباشر
      ticker_tag: "نشاط المنصة مباشرة",
      ticker_purchase: "شراء عملات",
      ticker_funded: "اكتمل تمويل طرح",
      ticker_distribution: "توزيع أرباح",
      ticker_rent: "تحصيل إيجار",
      mp_rent_per_mo: "الإيجار / شهرياً",
      mp_coin_price: "سعر العملة",
      mp_yield_index_title: "مؤشر العائد المُرَجَّح المباشر",
      mp_yield_index_sub: "متوسط العائد السنوي المستهدف عبر جميع الطروحات النشطة والمكتملة، مرجَّحاً بحجم التمويل.",
      why_tag: "لماذا إيجار مِنت",
      why_title: "موثوقية كغرفة مقاصة، ومرونة سعرية كسوق مفتوح.",
      why_b1: "توزيع شهري حتمي: الإيجار_الشهري ÷ العملات_المُباعة.",
      why_b2: "يحصل المالك على كامل قيمة التمويل في يوم اكتماله.",
      why_b3: "لكل عملة تاريخ انتهاء معلوم — لا توجد التزامات دائمة.",
      why_b4: "عوائد المستثمر تتزايد نسبياً مع عدد العملات. لا رسوم خفية في الإصدار الأول.",
      cta_title_1: "افتح حسابك.",
      cta_title_2: "ابدأ في أقل من ٦٠ ثانية.",
      cta_btn: "إنشاء حساب ←",

      // الفريق المؤسس
      team_tag: "الفريق المؤسس",
      team_title: "فريق ميداني، يدعمه استشاري قانوني متخصص.",
      team_sub: "فريق صغير بخبرة عميقة في علم البيانات والتمويل والقانون التجاري السعودي — هدفنا جعل الدخل العقاري متاحاً، ومتوافقاً، وشفّافاً.",
      team_1_name: "عبدالله النامي",
      team_1_role: "المؤسس والرئيس التنفيذي",
      team_1_bio: "عالِم بيانات ومتخصص في الذكاء الاصطناعي بخبرة تزيد عن ٢٠ عاماً في التقنية. سابقاً في أرامكو السعودية. ماجستير وبكالوريوس من جامعة الملك فهد للبترول والمعادن. يبني إيجار-منت لتحويل دخل الإيجارات إلى استثمار سائل.",
      team_1_link: "صفحة LinkedIn ←",
      team_2_name: "د. عدنان الزهراني",
      team_2_role: "المستشار القانوني والامتثال",
      team_2_bio: "محامٍ مرخّص (شركة مهنية مسجّلة لدى الهيئة السعودية للمحامين). تخصصات: العقارات، الخدمات المالية، المصرفية الإسلامية، الأوراق المالية، حوكمة الشركات.",
      team_2_link: "السجل في هيئة المحامين ←",
      login_tag: "تسجيل الدخول",
      login_title: "أهلاً بعودتك.",
      login_email: "البريد الإلكتروني",
      login_password: "كلمة المرور",
      login_submit: "دخول ←",
      login_no_account: "ليس لديك حساب؟",
      login_create: "أنشئ حساباً جديداً",
      reg_tag: "إنشاء حساب",
      reg_title: "اختَر دورك.",
      reg_role: "دورك على المنصة",
      reg_landlord: "مالك",
      reg_investor: "مستثمر",
      reg_tenant: "مستأجر",
      reg_amc: "شركة إدارة أصول",
      reg_name: "الاسم",
      reg_submit: "إنشاء الحساب ←",
      reg_have_account: "لديك حساب بالفعل؟",
      reg_signin: "تسجيل الدخول",
      reg_demo: "محفظة تجريبية بقيمة $50,000",
      reg_demo_body: "يحصل كل حساب جديد على رصيد افتراضي يُمكِّنك من تجربة المنصة من البداية إلى النهاية.",
      loading: "جارٍ التحميل…",
      processing: "جارٍ المعالجة…",
      ico_buy: "اشترِ عملات",
      ico_invest: "استثمر",
      ico_target_apy: "العائد المستهدف",
      ico_quantity: "الكمية",
      ico_cost_now: "التكلفة الآن",
      ico_est_monthly: "العائد الشهري المتوقع",
      ico_est_total: "الإجمالي المتوقع خلال المدة",
      ico_not_active: "غير نشط",
      ico_buy_n: "اشترِ {{n}} عملة ←",
      ico_owner: "المالك",
      ico_amc: "شركة الإدارة",
      ico_units_title: "وحدات المنشأة",
      ico_unit: "الوحدة",
      ico_rent: "الإيجار الشهري",
      ico_tenant: "المستأجر",
      ico_lease_end: "نهاية العقد",
      ico_feas_title: "دراسة الجدوى",
      ico_feas_by: "بواسطة",
      ico_returns_title: "كيف يعمل العائد",
      ll_tag: "المالك",
      ll_title: "منشآتي.",
      ll_add: "+ إضافة منشأة",
      ll_empty_title: "أضف أول منشأة، ثم وكّل شركة إدارة لنشر دراسة الجدوى.",
      ll_empty_tag: "لا توجد منشآت بعد",
      ll_status_ico_live: "طرح نشط",
      ll_status_awaiting: "بانتظار الدراسة",
      ll_status_needs_amc: "بحاجة لشركة إدارة",
      ll_delegate_amc: "وكّل شركة إدارة",
      ll_change_tenant: "تغيير المستأجر",
      ll_assign_tenant: "تعيين المستأجر",
      ll_view_ico: "عرض الطرح",
      ll_units: "الوحدات",
      ll_agg_rent: "الإيجار المجمّع",
      ll_amc: "شركة الإدارة",
      amc_tag: "مكتب إدارة الأصول",
      amc_title: "طلبات المنشآت.",
      amc_sub: "يوكّلك الملاك لإدارة منشآتهم. تحقّق من التدفقات النقدية، انشر دراسة الجدوى، وأطلق الطرح — كل ذلك في نموذج واحد.",
      amc_pending: "بانتظار الدراسة",
      amc_publish: "انشر دراسة الجدوى ←",
      amc_view_ico: "عرض الطرح الحي",
      amc_empty: "اطلب من الملاك تعيين حسابك على منشآتهم.",
      wal_tag: "المحفظة",
      wal_title: "الرصيد.",
      wal_current: "الرصيد الحالي",
      wal_topup_tag: "شحن (محاكاة)",
      wal_topup_title: "إضافة رصيد",
      wal_amount: "المبلغ (دولار)",
      wal_add: "أضف",
      act_tag: "الحركات",
      act_title: "السجل.",
      act_empty: "لا توجد حركات بعد",
      act_when: "التاريخ",
      act_type: "النوع",
      act_desc: "التفاصيل",
      act_amount: "المبلغ",
      currency_label: "العملة",
      ll_add_facility: "إضافة منشأة",
      ll_facility_name: "اسم المنشأة",
      ll_address: "العنوان",
      ll_image_url: "رابط صورة (اختياري)",
      ll_description: "الوصف",
      ll_units_header: "الوحدات",
      ll_aggregate_rent: "الإيجار المُجمَّع",
      ll_add_unit: "+ وحدة",
      ll_unit_name: "اسم الوحدة",
      ll_unit_rent: "الإيجار الشهري",
      ll_unit_tenant: "اسم المستأجر (اختياري)",
      ll_unit_lease_end: "نهاية العقد",
      ll_create_facility: "إنشاء المنشأة",
      ll_choose_amc: "اختر شركة إدارة الأصول",
      ll_amc_pick: "اختر شركة إدارة مُسجَّلة…",
      ll_amc_none: "لا توجد شركات إدارة مُسجَّلة بعد",
      ll_amc_help: "ستقوم شركة إدارة الأصول بالتحقق من المنشأة وتحديد افتراضات الإشغال والعائد ثم إطلاق الطرح نيابةً عنك.",
      ll_delegate_btn: "تفويض",
      ll_tenant_email: "البريد الإلكتروني للمستأجر",
      ll_tenant_help: "في النسخة التجريبية يدفع مستأجر واحد إجمالي الإيجار. شركة إدارة الأصول تتولى تأجير الوحدات منفردةً خارج المنصة.",
      ll_assign_btn: "تعيين",
      amc_publish_dialog: "دراسة الجدوى",
      amc_agg_rent: "الإيجار الشهري المُجمَّع",
      amc_units: "الوحدات",
      amc_owner: "المالك",
      amc_f_hist_rent: "الإيجار السنوي التاريخي",
      amc_f_occupancy: "نسبة الإشغال المتوقّعة %",
      amc_f_growth: "نمو الإيجار سنوياً %",
      amc_f_maint: "تكلفة الصيانة الشهرية",
      amc_f_apy: "العائد السنوي المستهدف %",
      amc_f_duration: "مدة الطرح (أشهر)",
      amc_f_monthly_fee: "رسوم شركة الإدارة الشهرية % (من صافي الإيجار)",
      amc_f_setup_fee: "رسوم التأسيس % (من قيمة التمويل)",
      amc_f_total_coins: "إجمالي العملات المُصدَرة",
      amc_f_comment: "تعليق شركة إدارة الأصول / ملخّص تنفيذي",
      amc_f_comment_ph: "أهم المخاطر، رؤية السوق، استراتيجية التأجير…",
      amc_math_title: "معاينة الأرقام الحيّة",
      amc_math_eff: "صافي شهري",
      amc_math_net: "نصيب المستثمرين شهرياً",
      amc_math_raise: "التمويل المستهدف",
      amc_math_price: "سعر العملة",
      amc_math_advance: "دفعة المالك المقدّمة",
      amc_math_setup: "رسوم التأسيس",
      amc_math_monthly: "الرسوم الشهرية",
      amc_math_apy: "العائد المستهدف",
      amc_submit: "نشر الدراسة وإطلاق الطرح",
      port_tag: "المستثمر",
      port_title: "محفظتي الاستثمارية.",
      port_invested: "إجمالي الاستثمار",
      port_earned: "إجمالي العوائد",
      port_next_month: "العائد المتوقّع للشهر القادم",
      port_holdings: "العملات المملوكة",
      port_empty: "لا تمتلك عملات بعد.",
      port_browse: "تصفّح سوق الطروحات ←",
      port_col_property: "المنشأة",
      port_col_coins: "العملات",
      port_col_invested: "المستثمر",
      port_col_earned: "العائد المُحقَّق",
      port_col_monthly: "الشهري",
      port_col_progress: "التقدّم",
      ten_tag: "المستأجر",
      ten_title: "إيجاراتي.",
      ten_empty_title: "لا توجد عقود إيجار مُعيّنة لك.",
      ten_empty_sub: "اطلب من المالك تعيين حسابك على منشأة.",
      ten_rent_label: "الإيجار",
      ten_last_paid: "آخر دفعة",
      ten_next: "التالية",
      ten_pay_btn: "ادفع {{amount}} عن الشهر رقم {{n}} ←",
      jc_title: "ارحل في رحلة الصفقة — مرحلةً تلو الأخرى.",
      jc_sub: "كل مرحلة تُظهر ما الذي يأتي به الطرف (المُدخلات) وما الذي يستلمه (المُخرجات). الأرقام تُحدَّث لحظياً مع كل تعديل.",
      jc_stage_in: "المُدخلات",
      jc_stage_out: "المُخرجات",
      jc_stage_role: "الدور",
      jc1_step: "٠١",
      jc1_role: "المالك",
      jc1_title: "تسجيل المنشأة",
      jc1_desc: "يُدرج المنشأة بإيجارها الشهري الإجمالي ومدة الطرح المطلوبة.",
      jc1_in_rent: "إجمالي الإيجار الشهري",
      jc1_in_duration: "مدة الطرح",
      jc1_in_net_annual: "متوسط الدخل السنوي الصافي (آخر ٣ سنوات)",
      jc1_in_years: "عدد سنوات الطرح للمستثمرين",
      jc1_in_discount: "إجمالي نسبة الربح المحتمل للمستثمرين خلال المدة",
      jc1_out_total: "إجمالي صافي الدخل خلال المدة",
      jc1_out_discount: "إجمالي قيمة الربح المحتمل للمستثمرين خلال المدة",
      jc1_out_landlord_today: "صافي النقد المتوقع اليوم للمالك",
      tip_total_net: "الدخل السنوي الصافي × عدد سنوات الطرح",
      tip_discount_total: "إجمالي صافي الدخل − قيمة التمويل = إجمالي ما يربحه المستثمرون.",
      tip_landlord_today: "إجمالي صافي الدخل − إجمالي خصم المستثمرين = ما يصل للمالك اليوم فعلياً.",
      tip_occ: "متوسط نسبة الإشغال المتوقعة خلال مدة الطرح.",
      tip_maint: "تكلفة الصيانة الشهرية المقدّرة، تُدفع لشركة الإدارة التي تتولى التشغيل والصيانة طوال المدة.",
      tip_apy: "العائد السنوي الذي تَعِد به شركة إدارة الأصول للمستثمرين.",
      tip_mfee: "نسبة من صافي الدخل الشهري تستلمها شركة إدارة الأصول.",
      tip_sfee: "نسبة من قيمة التمويل تُدفع لشركة الإدارة عند اكتمال الطرح.",
      tip_eff: "الدخل الشهري الصافي (بعد التشغيل والصيانة).",
      tip_net: "الدخل الشهري الصافي × (١ − نسبة الرسوم الشهرية لشركة الإدارة)",
      tip_raise: "إجمالي صافي الدخل ÷ (١ + نسبة الخصم للمستثمرين)",
      tip_price: "قيمة التمويل المستهدفة ÷ ١٠٠٬٠٠٠",
      tip_advance: "قيمة التمويل − رسوم تأسيس شركة الإدارة",
      tip_sfee_out: "قيمة التمويل × نسبة رسوم التأسيس",
      tip_mfee_out: "الدخل الشهري الصافي × نسبة الرسوم الشهرية",
      tip_coins: "كم عملة تختار تملّكها من إجمالي ١٠٠٬٠٠٠.",
      tip_pay: "العملات × سعر العملة",
      tip_monthly: "العملات × (نصيب المستثمرين ÷ ١٠٠٬٠٠٠)",
      tip_total_in: "العائد الشهري × عدد الأشهر",
      tip_roi: "(الإجمالي المستلم − المدفوع) ÷ المدفوع",
      tip_net_gain: "الإجمالي المستلم − المدفوع",
      tip_apy_simple: "إجمالي العائد ÷ عدد السنوات (بدون تركيب)",
      tip_be: "المدفوع ÷ العائد الشهري",
      tip_t_pay: "نفس المبلغ الذي يدفعه المستأجر شهرياً كالمعتاد.",
      tip_advance_req: "المنصة لا تطلب من المستأجر أي دفعة مقدّمة أبداً.",
      tip_split: "كل دولار من صافي الدخل يُقسَّم بين شركة الإدارة وحاملي العملات.",
      tip_term_total: "إجمالي صافي الدخل الذي يمر عبر المنصة خلال المدة كاملةً.",
      share_link: "نسخ رابط المشاركة",
      share_card: "تحميل بطاقة المشاركة (PNG)",
      share_copied: "تم نسخ الرابط",
      apply_landlord: "استخدم هذه الأرقام كمالك ←",
      apply_amc: "استخدم هذه الأرقام كشركة إدارة ←",
      apply_register: "سجّل لاستخدام السيناريو ←",
      scenario_loaded: "تم تطبيق سيناريو الحاسبة على هذا النموذج",
      tip_ico_rent: "إجمالي الإيجار الشهري لكل وحدات المنشأة.",
      tip_ico_duration: "عدد أشهر التوزيع على حاملي العملات.",
      tip_ico_coins: "إجمالي العملات المُصدَرة لهذا الطرح.",
      tip_ico_price: "السعر الذي دفعه المستثمر مقابل كل عملة عند الإصدار.",
      tip_ico_return: "صافي الإيجار الشهري ÷ إجمالي العملات — حصة كل عملة شهرياً.",
      tip_ico_raise: "قيمة التمويل المستهدفة (سعر العملة × عدد العملات).",
      tip_ico_sold: "العملات المُباعة حتى الآن. عندما تساوي الإجمالي يكتمل التمويل.",
      tip_ico_distributed: "إجمالي ما وُزِّع على حاملي العملات منذ الإطلاق.",
      tip_ico_apy: "العائد السنوي المستهدف الموعود في دراسة الجدوى.",
      jc2_step: "٠٢",
      jc2_role: "شركة إدارة الأصول",
      jc2_title: "نشر دراسة الجدوى",
      jc2_desc: "تحدد نسبة الإشغال والصيانة والعائد المستهدف ورسومها — فتُحسب أرقام الطرح كاملةً.",
      jc2_in_occ: "نسبة الإشغال المتوقعة",
      jc2_in_maint: "تكلفة الصيانة الشهرية",
      jc2_in_apy: "العائد السنوي المستهدف للمستثمرين",
      jc2_in_mfee: "رسوم شركة الإدارة الشهرية % (من صافي الإيجار)",
      jc2_in_sfee: "رسوم التأسيس % (من قيمة التمويل)",
      jc2_out_eff: "صافي الإيجار الشهري بعد الصيانة",
      jc2_out_net: "نصيب المستثمرين شهرياً",
      jc2_out_raise: "قيمة التمويل المستهدفة (الدفعة المتاحة)",
      jc2_out_price: "سعر العملة (١٠٠٬٠٠٠ ثابت)",
      jc2_out_advance: "ما يستلمه المالك عند اكتمال التمويل",
      jc2_out_sfee: "رسوم التأسيس (تُدفع عند اكتمال التمويل)",
      jc2_out_mfee: "الرسوم الشهرية (كل شهر)",
      jc3_step: "٠٣",
      jc3_role: "المستثمر",
      jc3_title: "شراء العملات",
      jc3_desc: "يحدد عدد العملات التي سيشتريها بالسعر الذي اعتمدته دراسة الجدوى.",
      jc3_in_coins: "عدد العملات",
      jc3_out_pay: "المبلغ الذي تدفعه اليوم",
      jc3_out_monthly: "العائد الشهري إلى محفظتك",
      jc3_out_total: "الإجمالي خلال المدة",
      jc3_out_net: "صافي الربح",
      jc3_out_roi: "إجمالي العائد",
      jc3_out_apy: "العائد السنوي (بسيط)",
      jc3_out_be: "أشهر استرداد رأس المال",
      jc4_step: "٠٤",
      jc4_role: "المستأجر",
      jc4_title: "دفع الإيجار — توزيع تلقائي",
      jc4_desc: "كل شهر يدفع المستأجر نفس الإيجار. تُقسّمه المنصة تلقائياً: رسوم شركة الإدارة (تشمل التشغيل والصيانة) لشركة الإدارة، والباقي لحاملي العملات. لا يتدخل المالك حتى انتهاء المدة (يستردّ الأصل أو يجدّد بطرح جديد).",
      jc4_in_pay: "الفاتورة الشهرية (كالمعتاد)",
      jc4_in_advance: "المطلوب دفعه مقدّماً",
      jc4_out_split: "إلى أين يذهب كل دولار من الإيجار الشهري",
      jc4_out_split_maint: "الصيانة · لشركة الإدارة",
      jc4_out_split_amc: "رسوم شركة الإدارة",
      jc4_out_split_inv: "للموزَّعين على حاملي العملات",
      jc4_out_term_total: "إجمالي ما يدفعه المستأجر خلال المدة كاملة",
    },
  },
};

const savedLang = typeof localStorage !== "undefined" ? localStorage.getItem("lm_lang") : null;

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang || "ar",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});
export function applyDir(lang) {
  if (typeof document === "undefined") return;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lang;
}

applyDir(i18n.language);
